import React, { useState } from "react";
import { Setp1 } from "./step-1";
import Step02 from "./step-2";
import Step03 from "./step-3";
import { ScoreButton } from "../Scores/ScoreButton";
import { Modal } from "../Modal/Modal";
import { Result } from "../Result/Result";
import intl from "react-intl-universal";
import { getParameterByName } from "../../querystring.js";

import ptBrLocale from "../../locales/pt-BR.json";
import enUsLocale from "../../locales/en-US.json";
import esESLocale from "../../locales/es-ES.json";

const locales = {
  "pt-BR": ptBrLocale,
  "en-US": enUsLocale,
  "es-ES": esESLocale,
};

function NpsCalc() {
  const querystring = getParameterByName("lang");

  const language = querystring ? querystring : navigator.language;

  const currentLocale = locales[language] ? language : "pt-BR";

  intl.init({
    currentLocale,
    locales,
  });

  const [answers, setAnswers] = useState([
    { value: 0, scorenumber: 0 },
    { value: 0, scorenumber: 1 },
    { value: 0, scorenumber: 2 },
    { value: 0, scorenumber: 3 },
    { value: 0, scorenumber: 4 },
    { value: 0, scorenumber: 5 },
    { value: 0, scorenumber: 6 },
    { value: 0, scorenumber: 7 },
    { value: 0, scorenumber: 8 },
    { value: 0, scorenumber: 9 },
    { value: 0, scorenumber: 10 },
  ]);

  let detractors = 0;
  let neutral = 0;
  let promotores = 0;
  let detractorsPercentage = 0;
  let neutralPercentage = 0;
  let promotoresPercentage = 0;
  let total = 0;
  let nps = undefined;
  let npsClass = "critical";
  let varience = undefined;
  let errorMargin = "errorNote";

  answers.forEach((score) => {
    if (score.scorenumber <= 6) {
      detractors += score.value;
    } else if (score.scorenumber <= 8) {
      neutral += score.value;
    } else {
      promotores += score.value;
    }
  });

  total = Number(detractors) + Number(neutral) + Number(promotores);

  if (total > 0) {
    detractorsPercentage = ((detractors / total) * 100).toFixed(2);
    promotoresPercentage = ((promotores / total) * 100).toFixed(2);
    neutralPercentage = ((neutral / total) * 100).toFixed(2);

    nps = Math.round(promotoresPercentage - detractorsPercentage);

    if (nps > 0 && nps <= 50) {
      npsClass = "improvement";
    } else if (nps > 50 && nps <= 75) {
      npsClass = "quality";
    } else if (nps > 75) {
      npsClass = "excellence";
    }

    if (nps < -100) {
      nps = -100;
    } else if (nps > 100) {
      nps = 100;
    }

    let d = (detractors / total) * Math.pow(-1 - nps / 100, 2);
    let n = (neutral / total) * Math.pow(0 - nps / 100, 2);
    let p = (promotores / total) * Math.pow(1 - nps / 100, 2);
    varience = d + n + p;
    errorMargin = "errorNote";
    varience = Math.round(varience * 100) / 100;
  }  

  function handleChange(index, value) {
    const newAnswers = answers.slice();

    newAnswers[index].value = value;

    setAnswers(newAnswers);
  }

  return (
    <div className="content">
      <div className="container">
        <Setp1>
          <div className="row">
            <div className="row-nps">
              
              {answers.map((item, index) => {
                return (
                  <ScoreButton
                    key={index}
                    scorenumber={item.scorenumber}
                    value={item.value}
                    handleChange={(value) => {
                      handleChange(index, value);
                    }}
                  />
                );
              })}
            </div>
          </div>
        </Setp1>
        <Step02
          detractorsValue={detractorsPercentage}
          neutralValue={neutralPercentage}
          promoterValue={promotoresPercentage}
        />
        <Step03 />
            <Modal />
        <div id="result-nps" style={{display: 'none', justifyContent: 'center'}}>
       
          <div className="col-lg-4 resultError">
            <Result
              text={intl.get("npscalc.margem")}
              value={typeof varience !== "undefined" ? "±" + varience : undefined}
              errorMargin={errorMargin}
            />
            </div>
          <div className="col-lg-4 resultNPS">
            <Result text="Seu Net Promoter Score é:" value={nps} npsClass={npsClass} />
          </div>

        </div>
      </div>
    </div>
    
  );
}

export default NpsCalc;


